import { render, staticRenderFns } from "./LogItem.vue?vue&type=template&id=fa97c2f6&scoped=true&"
import script from "./LogItem.vue?vue&type=script&lang=ts&"
export * from "./LogItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa97c2f6",
  null
  
)

export default component.exports